import { CheckEmailRegisterMeta, CheckEmailRegisterPayload } from 'types/store/CheckEmailRegister';
import { createAsyncReducer } from 'utils/Redux';

import { checkEmailRegisterActions } from '../actions';

export default createAsyncReducer<CheckEmailRegisterMeta, CheckEmailRegisterPayload>(checkEmailRegisterActions);
